"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var config_1 = __importDefault(require("config"));
var api_1 = __importDefault(require("api"));
var use_stores_1 = require("hooks/use-stores");
var Login_1 = __importDefault(require("components/login/Login"));
var SplashScreen_1 = __importDefault(require("components/SplashScreen"));
var Root_1 = __importDefault(require("./components/Root"));
var use_notification_1 = require("./hooks/use-notification");
var Notification_1 = require("./components/Notification");
var mobx_react_1 = require("mobx-react");
var UserStore_1 = require("./stores/UserStore");
var ForgotPassword_1 = __importDefault(require("./components/forgot-password/ForgotPassword"));
var ResetPassword_1 = __importDefault(require("./components/reset-password/ResetPassword"));
var Routes = mobx_react_1.observer(function () {
    var _a = react_1.useState(false), userCheck = _a[0], setUserCheck = _a[1];
    var _b = react_1.useState(false), exiting = _b[0], setExiting = _b[1];
    var history = react_router_dom_1.useHistory();
    var _c = use_stores_1.useStores(), userStore = _c.userStore, prefsStore = _c.prefsStore, apiStore = _c.apiStore;
    var exitTimeoutRef = react_1.useRef(null);
    var checkTimeoutRef = react_1.useRef(null);
    var notification = use_notification_1.useNotification();
    var location = react_router_dom_1.useLocation();
    react_1.useEffect(function () {
        var localUser = localStorage.getItem(config_1.default.storageKeys.USER);
        var localPrefs = localStorage.getItem(config_1.default.storageKeys.PREFS);
        if (localUser === null) {
            if (location.pathname !== '/forgot-password' && location.pathname !== '/reset-password') {
                history.replace("/login");
            }
            exitToScreen();
        }
        else {
            api_1.default.getUser()
                .then(function (response) {
                userStore.setData(response.data);
                if (history.location.pathname === "/login") {
                    if (userStore.data.databaseConnection === UserStore_1.CODA)
                        history.replace("/products");
                    else
                        history.replace("/");
                    return;
                }
                exitToScreen();
            }, function (error) {
                localStorage.removeItem(config_1.default.storageKeys.USER);
                history.replace('/login');
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: 'Your login session has expired.'
                });
                exitToScreen();
            });
        }
        if (localPrefs !== null) {
            prefsStore.setData(JSON.parse(localPrefs));
        }
        return function () {
            clearTimeout(exitTimeoutRef.current);
            clearTimeout(checkTimeoutRef.current);
        };
    }, []);
    react_1.useEffect(function () {
        if (apiStore.data.error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: apiStore.data.error
            });
        }
    }, [apiStore.data]);
    react_1.useEffect(function () {
        if (userCheck && userStore.data === null)
            history.replace('/login');
    }, [userStore.data]);
    var exitToScreen = function () {
        clearTimeout(exitTimeoutRef.current);
        clearTimeout(checkTimeoutRef.current);
        exitTimeoutRef.current = setTimeout(function () {
            setExiting(true);
            checkTimeoutRef.current = setTimeout(function () {
                setUserCheck(true);
            }, 500);
        }, 1000);
    };
    return userCheck ? (react_1.default.createElement("div", null,
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: '/reset-password', component: ResetPassword_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/forgot-password', component: ForgotPassword_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/login", component: Login_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", component: Root_1.default })))) : react_1.default.createElement(SplashScreen_1.default, { exiting: exiting });
});
exports.default = Routes;
